<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.veiculo_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.veiculo_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.veiculo_motorista.length > 0"
          >
            <span class="nav-link-in">
              Motoristas
              <i class="fa fa-users"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.veiculo_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.veiculo_ger_risco.length > 0"
          >
            <span class="nav-link-in">
              Ger. Risco
              <i class="fa fa-info-circle"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.veiculo_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.veiculo_ger_risco_erro.length > 0"
          >
            <span class="nav-link-in">
              Erros Ger. Risco
              <i class="fa fa-exclamation-triangle"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.veiculo_id + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.veiculo_foto.length > 0"
          >
            <span class="nav-link-in">
              Foto do Documento
              <i class="fa fa-picture-o"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.veiculo_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Capacidade kg(Minimo)</th>
                <th style="width: 10%">Capacidade kg(Maximo)</th>
                <th style="width: 10%">Capacidade m³(Minimo)</th>
                <th style="width: 10%">Capacidade m³(Maximo)</th>
                <th style="width: 10%">CNPJ/CPF</th>
                <th style="width: 30%">Razão Social/Nome</th>
                <th style="width: 20%">Municipio</th>
                <th style="width: 10%">Código gerenciamento de risco</th>
                <th style="width: 10%">
                  Código de pesquisa gerenciamento de risco
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.capacidade_kg_min }}
                </td>
                <td>
                  {{ rowData.capacidade_kg }}
                </td>
                <td>
                  {{ rowData.capacidade_m3_min }}
                </td>
                <td>
                  {{ rowData.capacidade_m3 }}
                </td>
                <td>
                  <span v-if="rowData.pessoa !== null">
                    <span v-if="rowData.pessoa.pessoa_juridica !== null">{{
                      onFormataCnpj(
                        rowData.pessoa.pessoa_juridica.cnpj_base,
                        rowData.pessoa.pessoa_juridica.cnpj_filial,
                        rowData.pessoa.pessoa_juridica.cnpj_digito
                      )
                    }}</span>
                    <span v-if="rowData.pessoa.pessoa_exterior !== null">{{
                      rowData.pessoa.pessoa_exterior.cuit
                    }}</span>
                    <span v-if="rowData.pessoa.pessoa_fisica !== null">{{
                      rowData.pessoa.pessoa_fisica.cpf
                    }}</span>
                  </span>
                </td>
                <td>
                  <span v-if="rowData.pessoa !== null">
                    <span v-if="rowData.pessoa.pessoa_juridica !== null">{{
                      rowData.pessoa.pessoa_juridica.razao_social
                    }}</span>
                    <span v-if="rowData.pessoa.pessoa_exterior !== null">{{
                      rowData.pessoa.pessoa_exterior.nome
                    }}</span>
                    <span v-if="rowData.pessoa.pessoa_fisica !== null">{{
                      rowData.pessoa.pessoa_fisica.nome
                    }}</span>
                  </span>
                </td>
                <td>
                  {{ rowData.municipio.nome }}
                </td>
                <td>
                  {{ rowData.cd_gerenciamento_risco }}
                </td>
                <td>
                  {{ rowData.cdpesquisa_gerenciamento_risco }}
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 15%">Tipo Veículo</th>
                <th style="width: 15%">Combustível</th>
                <th style="width: 15%">Câmbio</th>
                <th style="width: 15%">Marca</th>
                <th style="width: 15%">Modelo</th>
                <th style="width: 15%">Blindado</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="rowData.veiculo_detalhe.tp_veiculo != null">
                    {{ rowData.veiculo_detalhe.tp_veiculo.descr }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      rowData.veiculo_detalhe.param_tipo_combustivel != null
                    "
                  >
                    {{ rowData.veiculo_detalhe.param_tipo_combustivel.descr }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.tp_cambio != null">
                    {{ rowData.veiculo_detalhe.tp_cambio.descr }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.marca_veiculo != null">
                    {{ rowData.veiculo_detalhe.marca_veiculo.descr }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.modelo_veiculo != null">
                    {{ rowData.veiculo_detalhe.modelo_veiculo.descr }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.is_blindado != null">
                    {{ rowData.veiculo_detalhe.is_blindado.descr }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Ano Fabricação</th>
                <th style="width: 10%">Ano Modelo</th>
                <th style="width: 10%">Cilindradas</th>
                <th style="width: 10%">Potência</th>
                <th style="width: 10%">Chassi</th>
                <th style="width: 10%">Cor</th>
                <th style="width: 20%">Observação</th>
                <th style="width: 20%">Transportadora</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="rowData.veiculo_detalhe.ano_fabricacao">
                    {{ rowData.veiculo_detalhe.ano_fabricacao }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.ano_modelo">
                    {{ rowData.veiculo_detalhe.ano_modelo }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.cilindradas">
                    {{ rowData.veiculo_detalhe.cilindradas }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.potencia">
                    {{ rowData.veiculo_detalhe.potencia }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.chassi">
                    {{ rowData.veiculo_detalhe.chassi }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.cor_veiculo != null">
                    {{ rowData.veiculo_detalhe.cor_veiculo.descr }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.veiculo_detalhe.obs">
                    {{ rowData.veiculo_detalhe.obs }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.pessoa_agenciador != null">
                    {{
                      rowData.pessoa_agenciador.pessoa_juridica.razao_social +
                        " - " +
                        onFormataCnpj(
                          rowData.pessoa_agenciador.pessoa_juridica.cnpj_base,
                          rowData.pessoa_agenciador.pessoa_juridica.cnpj_filial,
                          rowData.pessoa_agenciador.pessoa_juridica.cnpj_digito
                        )
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t2' + rowData.veiculo_id + ''"
          v-if="rowData.veiculo_motorista.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Nome</th>
                <th style="width: 15%">CPF</th>
                <th style="width: 10%">CNH</th>
                <th style="width: 10%">Data de vencimento CNH</th>
                <th style="width: 10%">Categoria</th>
                <th style="width: 5%">Tipo de vínculo</th>
                <th style="width: 20%">Obs.</th>
                <th style="width: 5%">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.veiculo_motorista"
              >
                <td>
                  {{ item.pessoa_motorista.pessoa_fisica.nome }}
                </td>
                <td>
                  {{ item.pessoa_motorista.pessoa_fisica.cpf }}
                </td>
                <td>
                  {{ item.pessoa_motorista.cnh }}
                </td>
                <td>
                  {{ formatDate(item.pessoa_motorista.dt_vencimento_cnh) }}
                </td>
                <td>
                  <span v-if="item.pessoa_motorista.categoria != null">
                    {{ item.pessoa_motorista.categoria.descr }}
                  </span>
                </td>
                <td>
                  <span v-if="item.pessoa_motorista.categoria != null">
                    {{ item.pessoa_motorista.tp_vinculo.descr }}
                  </span>
                </td>
                <td>
                  {{ item.pessoa_motorista.obs }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t3' + rowData.veiculo_id + ''"
          v-if="rowData.veiculo_ger_risco_erro.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Descrição</th>
                <th style="width: 10%">Tipo erro</th>
                <th style="width: 60%">XML</th>
                <th style="width: 10%">Data</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.veiculo_ger_risco_erro"
              >
                <td>
                  {{ item.descr }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.tp_erro.valor == 1"
                    >{{ item.tp_erro.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.tp_erro.valor == 2"
                    >{{ item.tp_erro.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="item.tp_erro.valor == 3"
                    >{{ item.tp_erro.descr }}</span
                  >
                </td>
                <td>
                  <span v-if="item.xml != null">
                    {{ item.xml }}
                  </span>
                </td>
                <td>
                  {{ formatDateHora(item.dt_inc) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t4' + rowData.veiculo_id + ''"
          v-if="rowData.veiculo_ger_risco.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 3%">Código veículo</th>
                <th style="width: 5%">Placa</th>
                <th style="width: 20%">Situação</th>
                <th style="width: 5%">Tipo situação</th>
                <th style="width: 5%">Data consulta</th>
                <th style="width: 5%">Data expiração</th>
                <th style="width: 4%">Senha</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.veiculo_ger_risco"
              >
                <td>
                  {{ item.cd_veiculo }}
                </td>
                <td>
                  {{ item.placa }}
                </td>
                <td>
                  {{ item.situacao }}
                </td>
                <td>
                  {{ item.tp_situacao.descr }}
                </td>
                <td>
                  {{ formatDateHora(item.dt_consulta) }}
                </td>
                <td>
                  {{ formatDateHora(item.dt_expiracao) }}
                </td>
                <td>
                  {{ item.senha }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t5' + rowData.veiculo_id + ''"
          v-if="rowData.veiculo_foto.length > 0"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 2%">N° da foto</th>
                <th style="width: 15%">Link</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="(item, i) in rowData.veiculo_foto"
              >
                <td>
                  {{ i + 1 }}
                </td>
                <td>
                  <a
                    @click="goLink(item.url_foto)"
                    target="_blank"
                    onMouseOver="this.style.color='#404E67'"
                    onMouseOut="this.style.color='#0097e6'"
                  >
                    <span v-if="item.nome_foto != null">
                      {{ item.nome_foto }}
                    </span>
                    <span v-if="item.nome_foto == null">
                      {{ item.url }}
                    </span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    goLink(data) {
      window.open(data, "_blank");
    },
  },
};
</script>